import { render, staticRenderFns } from "./trTag.vue?vue&type=template&id=97fc6808&"
import script from "./trTag.vue?vue&type=script&lang=js&"
export * from "./trTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports